import React, { useContext } from 'react';
import ClipIcon from 'icons/Clip.icon';
import DocumentViewContext from 'providers/DocumentView/DocumentView.context';
import { Question } from '../../models/QAndA';
import { useTranslation } from 'react-i18next';
import { Button } from 'ncoded-component-library';
import classNames from 'classnames';
import DataRoomContext from '../../providers/DataRoom/DataRoom.context';

import './RelatedFileQa.styles.scss';
import './RelatedFileQa.styles.responsive.scss';

type RelatedFileQaProps = {
  className?: string;
  question: Question;
};

const RelatedFileQa: React.FC<RelatedFileQaProps> = (props) => {
  const { question, className } = props;
  const { dataRoomNode, hasAccessDataRoomNode } = question || {};
  const { _id: nodeId, name } = dataRoomNode || {};

  const {
    doesntHaveAccess,
    qaSide,
    dataRoom: { name: dataRoomName, userId, dealRoomId },
  } = useContext(DataRoomContext);
  const { openNode } = useContext(DocumentViewContext);

  const { t } = useTranslation();

  const classes = classNames('related-file-qa', className);

  if (!name) return <p className={classes}>{t('generalQuestion')}</p>;

  if (!hasAccessDataRoomNode || !doesntHaveAccess) {
    return (
      <p className={classes}>
        <ClipIcon />
        {name}
      </p>
    );
  }

  return (
    <Button
      variant="link"
      className={classes}
      icon={ClipIcon}
      onClick={() => {
        if (!nodeId) return;

        openNode(dataRoomNode, {
          dataRoomName,
          userSide: qaSide,
          ownerId: userId,
          dealRoomId,
        });
      }}
    >
      {name}
    </Button>
  );
};

export default RelatedFileQa;
